import VueCookies from 'vue-cookies'
import languageBundle from '@kirschbaum-development/laravel-translations-loader/json!@kirschbaum-development/laravel-translations-loader';
import PrimeVue from 'primevue/config';
import {FilterService} from 'primevue/api';
import {registerDataTableFilterModes, calculateFontAutosize} from './utility'
import Teleport from 'vue2-teleport'
import MasonryWall from '@yeger/vue2-masonry-wall'

window.axios = require('axios');
window.calculateFontAutosize = calculateFontAutosize

registerDataTableFilterModes(FilterService)

Vue.use(VueCookies);
VueCookies.config('30d');
Vue.use(PrimeVue);
Vue.use(Teleport, {
    name: 'teleport', // optional, use to rename component
})
Vue.use(MasonryWall);

Lang.setLocale(Laravel.activeLanguage);
Lang.setFallback('en');
Lang.setMessages(languageBundle);

/* @todo - refactoring: nur mehr axios verwenden */
Vue.http.interceptors.push((request, next) => {
    request.headers.set('X-CSRF-TOKEN', Laravel.csrfToken);
    next();
});

axios.interceptors.request.use(function (config) {
    config.headers['X-CSRF-TOKEN'] = Laravel.csrfToken;
    return config;
});

// Call Stack normalization
window.history.replaceState({}, document.title, window.location.href.replace(/\?.*/,''));
